const isDevelopmentMode = process.env.NODE_ENV === 'development'
const environment = process.env.REACT_APP_ENVIRONMENT;

let API_URL // for calls to the odontia booking backend 
let API_CORE // for calls too the Dentli Core API
if (isDevelopmentMode && environment === 'development') {
    API_URL = 'https://api.booking.staging.dentalmedia.io/api'
    API_CORE = 'http://eu.core.dentli.test'
} else {
    if (environment === 'staging') {
        API_URL = 'https://api.booking.staging.dentalmedia.io/api'
        API_CORE = 'https://eu-core.staging.dentli.io'
    }
    if (environment === 'production') {
        API_URL = 'https://api.booking.dentalmedia.io/api'
        API_CORE = 'https://eu.core.dentli.io'
    }
}

export const envConfig = {
    API_URL: API_URL,
    GOOGLE_MAP_KEY: 'AIzaSyDRZpvk0o-pmqHDeCVmCZHpVI7hByB3p7E',
    DIGGER_KEY:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vYXBpLWRpZ2dlci12Mi5kaWd0ZWN0aXZlLmNvbS9kaWdnZXItZGFzaGJvYXJkL2FwaS9hdXRoL2xvbmctbGl2aW5nLXRva2VuIiwiaWF0IjoxNzY1ODEwMzcyLCJleHAiOjE4Mjg4ODIzNzIsIm5iZiI6MTc2NTgxMDM3MiwianRpIjoidU53cmtVNGUxZDR3dkNWYSIsInN1YiI6IjQxIiwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyIsInVzZXJJZCI6NDEsIm9yZ2FuaXphdGlvbklkIjo2MDA3MywibWFuYWdlck9yZ2FuaXphdGlvbklkIjo2fQ.QnQOLSdVP5z0T_ozt0Y0rq6tbGqfiGZw7jAJcgdsHeE',
    CHAIN_NAME: 'Odontia',
    API_CORE: API_CORE,
    DIGGER_API: 'https://api-digger-v2.digtective.com',
    ENVIRONMENT: environment,
}
